// extracted by mini-css-extract-plugin
export default {"infoCitizen":"InfoCitizen_infoCitizen__marLh","box":"InfoCitizen_box__W2CYl","label":"InfoCitizen_label__7aOpJ","values":"InfoCitizen_values__cq0El"};